<template>
  <div class="register absolute">
    <div class="showbox" v-if="showbox">
      <div class="showTile">
        <img src="@assets/images/logo.png" alt="">

        小将文化 申请获得
      </div>
      <strong>
        以下权限
      </strong>
      <p>
        获得你的公开信息（昵称、头像、地区及性别）
      </p>

      <button  @click="btnfalse()">同意</button>
    </div>

    <!-- 选卡券 -->
    <SwitchAccounts :showCard="showCard" :cardList="cardList" @changeAccount="checkedCard" :title="''"></SwitchAccounts>

    <div class="shading" v-if="false">
      <div class="pictrue acea-row row-center-wrapper">
        <img :src="logoUrl" v-if="logoUrl" />
        <img src="@assets/images/logoWhrite.png" v-else />
      </div>
    </div>
    <div class="img">
      <img :src="logoUrl" alt="" />
      <!-- <img src="@assets/images/loginbanner.jpeg" alt="" /> -->
    </div>
    <!--  -->
    <div class="whiteBg" v-if="formItem === 1">
      <div class="title acea-row row-center-wrapper">
        <div
          class="item"
          :class="current === index ? 'on' : ''"
          v-for="(item, index) in navList"
          :key="index"
          @click="navTap(index)"
        >
          {{ item }}
        </div>
      </div>

      <div class="list" :hidden="current !== 0">
        <!-- <h2 class="htitle">登录</h2> -->
        <form @submit.prevent="submit">
          <div class="item">
            <div class="acea-row row-between-wrapper">
              <svg class="icon" aria-hidden="true" v-if="false">
                <use xlink:href="#icon-phone_"></use>
              </svg>
              <label for="">账号</label>
              <input
                type="text"
                placeholder="请输入账号"
                v-model="account"
                required
              />
            </div>
          </div>
          <div class="item">
            <div class="acea-row row-between-wrapper">
              <svg class="icon" aria-hidden="true" v-if="false">
                <use xlink:href="#icon-code_"></use>
              </svg>
              <label for="">密码</label>
              <input
                type="password"
                placeholder="请输入密码"
                v-model="password"
                required
              />
            </div>
          </div>
        </form>
        <div
          class="forgetPwd"
          @click="$router.push({ name: 'RetrievePassword' })"
          v-if="false"
        >
          <span class="iconfont icon-wenti"></span>忘记密码
        </div>
      </div>
      <div class="list" :hidden="current !== 1">
        <div class="item">
          <div class="acea-row row-between-wrapper">
            <svg class="icon" aria-hidden="true">
              <use xlink:href="#icon-phone_"></use>
            </svg>
            <input type="text" placeholder="输入手机号码" v-model="account" style="input::-webkit-input-placeholder{position：relative；left：20px;" />
          </div>
        </div>
        <!--  -->
        <div class="acea-row row-between row-bottom item two-item">
             <input
              type="text"
              placeholder="验证码"
              class="codeInput"
              v-model="imgCode"
            />
            <img class="img-code" @click="getCapt" :src="imgCodeUrl" />
        </div>
        <!--  -->
        <div class="item">
          <div class="align-left">
            <svg class="icon" aria-hidden="true">
              <use xlink:href="#icon-code_1"></use>
            </svg>
            <input
              type="text"
              placeholder="填写验证码"
              class="codeIput"
              v-model="captcha"
            />
            <button
              class="code"
              :disabled="disabled"
              :class="disabled === true ? 'on' : ''"
              @click="code"
            >
              {{ text }}
            </button>
          </div>
        </div>
      </div>
      <div class="logon" @click="loginMobile" :hidden="current !== 1">确认</div>
      <div class="logon" @click="submit" :hidden="current == 1">确认</div>
      <div class="tip" v-if="false">
        没有卡号?
        <span @click="formItem = 2" class="font-color-red">立即注册</span>
      </div>
    </div>
    <!-- ↑ -->
    <div class="whiteBg" v-else>
      <div class="title">注册卡号</div>
      <div class="list">
        <div class="item">
          <div>
            <svg class="icon" aria-hidden="true">
              <use xlink:href="#icon-phone_"></use>
            </svg>
            <input type="text" placeholder="输入手机号码" v-model="account" />
          </div>
        </div>
        <div class="item">
          <div class="align-left">
            <svg class="icon" aria-hidden="true">
              <use xlink:href="#icon-code_1"></use>
            </svg>
            <input
              type="text"
              placeholder="填写验证码"
              class="codeIput"
              v-model="captcha"
            />
            <button
              class="code"
              :disabled="disabled"
              :class="disabled === true ? 'on' : ''"
              @click="code"
            >
              {{ text }}
            </button>
          </div>
        </div>
        <div class="item">
          <div>
            <svg class="icon" aria-hidden="true">
              <use xlink:href="#icon-code_"></use>
            </svg>
            <input
              type="password"
              placeholder="填写您的登录卡密"
              v-model="password"
            />
          </div>
        </div>
      </div>
      <div class="logon" @click="register">注册</div>
      <div class="tip">
        已有卡号?
        <span @click="formItem = 1" class="font-color-red">立即登录</span>
      </div>
    </div>
    <div class="bottom" v-if="false"></div>
  </div>
</template>
<script>
import sendVerifyCode from "@mixins/SendVerifyCode";
import {
  islogin,
  login,
  loginMobile,
  loginCouponLogin,
  registerVerify,
  register
} from "@api/user";
import { getLogo,wechatAuth } from "@api/public";
import attrs, { required, alpha_num, chs_phone } from "@utils/validate";
import { validatorDefaultCatch } from "@utils/dialog";
import dayjs from "dayjs";
import cookie from "@utils/store/cookie";
import { parseQuery } from "@utils";
const BACK_URL = "login_back_url";
import {toAuth} from "@libs/wechat";

import SwitchAccounts from "@components/SwitchAccounts.vue";

export default {
  name: "Login",
  mixins: [sendVerifyCode],
  components: {
    SwitchAccounts
  },
  data: function() {
    return {
      navList: ["账号登录", "手机登录"],
      current: 0,
      account: "",
      password: "",
      captcha: "",
      formItem: 1,
      type: "login",
      logoUrl: "",
      showbox: false,
      showCard: false, //选择卡券
      cardList:[],
      imgCode: "", //图片验证码字
      imgCodeUrl: "http://xianbenxh.com/api/login/captcha" //图片验证码图
    };
  },
  mounted: function() {
    this.getLogoImage();
    // islogin();
    console.log(islogin());

    this.btnfalse();

    // 设置授权
    ///cookie.set(BACK_URL,"/", "Session");

    // islogin().then(data => {
    //   console.log(data);
    //   cookie.set("islogin",data.data.islogin, "Session")
    //   if (data.data.islogin == 1) {
    //     this.$router.push("/home");
    //   }
    // });

  },
  methods: {
    getCapt: function () {
      let imgPath = this.imgCodeUrl.split('?')[0]+'?id='+parseInt(Math.random()*100000);
      this.imgCodeUrl = imgPath;
    },
    checkedCard: function (val) {
      let {showCard, id} = val;
      loginCouponLogin({id: id}).then((res)=>{
        if(!res.data) return;
        this.showCard = showCard;
        let data = res.data;
        this.$store.commit("LOGIN", data.token, dayjs(data.expires_time));
        const backUrl = cookie.get(BACK_URL) || "/home";
        cookie.remove(BACK_URL);
        this.$router.replace({ path: backUrl });
        this.$router.push("/home");
      }).catch((err)=>{
        console.log(err);
      })
    },
    btnfalse(){
      toAuth();
      this.showbox = !this.showbox;
    },

    async getLogoImage() {
      let that = this;
      getLogo(3).then(res => {
        that.logoUrl = res.data.logo_url;
      });
    },
    async loginMobile() {
      var that = this;
      const { account, captcha } = that;
      try {
        await that
          .$validator({
            account: [
              required(required.message("手机号码")),
              chs_phone(chs_phone.message())
            ],
            captcha: [
              required(required.message("验证码")),
              alpha_num(alpha_num.message("验证码"))
            ]
          })
          .validate({ account, captcha });
      } catch (e) {
        return validatorDefaultCatch(e);
      }
      loginMobile({
        phone: that.account,
        captcha: that.captcha,
        spread: cookie.get("spread")
      })
        .then(res => {
          let data = res.data;

          if (res.data && res.data.couponList) {

            let arr = [];
            res.data.couponList.forEach((item, ind)=>{
              arr.push({
                coupon_price: item.coupon_price,
                id: item.id,
                cate_name: item.cate_name,
                imgUrl: item.imgUrl,
                type: item.type,
                title: item.title
              })
            })
            this.cardList = arr;
            this.showCard = true;

          } else {

            that.$store.commit("LOGIN", data.token, dayjs(data.expires_time));
            const backUrl = cookie.get(BACK_URL) || "/home";
            cookie.remove(BACK_URL);
            that.$router.replace({ path: backUrl });
            this.$router.push("/home");
          }

        })
        .catch(res => {
          that.$dialog.error(res.msg);
        });
    },
    async register() {
      var that = this;
      const { account, captcha, password } = that;
      try {
        await that
          .$validator({
            account: [
              required(required.message("手机号码")),
              chs_phone(chs_phone.message())
            ],
            captcha: [
              required(required.message("验证码")),
              alpha_num(alpha_num.message("验证码"))
            ],
            password: [
              required(required.message("密码")),
              attrs.range([6, 16], attrs.range.message("密码")),
              alpha_num(alpha_num.message("密码"))
            ]
          })
          .validate({ account, captcha, password });
      } catch (e) {
        return validatorDefaultCatch(e);
      }
      register({
        account: that.account,
        captcha: that.captcha,
        password: that.password,
        spread: cookie.get("spread")
      })
        .then(res => {
          that.$dialog.success(res.msg);
          that.formItem = 1;
        })
        .catch(res => {
          that.$dialog.error(res.msg);
        });
    },
    async code() {
      var that = this;
      const { account } = that;
      try {
        await that
          .$validator({
            account: [
              required(required.message("手机号码")),
              chs_phone(chs_phone.message())
            ]
          })
          .validate({ account });
      } catch (e) {
        return validatorDefaultCatch(e);
      }

      if (this.imgCode) {
        this.getCodeNum();
      } else {
        that.$dialog.error("请输入验证码！");
      }

    },
    getCodeNum: async function () {
        let that = this;
        if (that.formItem == 2) that.type = "register";
      await registerVerify({ phone: that.account, type: that.type,  verify: that.imgCode })
        .then(res => {
          that.$dialog.success(res.msg);
          that.sendCode();
        })
        .catch(res => {
          that.$dialog.error(res.msg);
        });
    },
    navTap: function(index) {
      this.current = index;
      this.account = "";
      console.log(this.current);
    },
    async submit() {
      const { account, password } = this;
      try {
        this.$validator({
          account: [
            required(required.message("账号")),
            attrs.range([5, 16], attrs.range.message("账号")),
            alpha_num(alpha_num.message("账号"))
          ],
          password: [
            required(required.message("密码")),
            attrs.range([6, 16], attrs.range.message("密码")),
            alpha_num(alpha_num.message("密码"))
          ]
        }).validate({ account, password });
      } catch (e) {
        return validatorDefaultCatch(e);
      }

      login({ account, password })
        .then(({ data }) => {
          this.$store.commit("LOGIN", data.token, dayjs(data.expires_time));
          const backUrl = cookie.get(BACK_URL) || "/home";
          cookie.remove(BACK_URL);
          this.$router.replace({ path: backUrl });
          this.$router.push("/home");
        })
        .catch(e => {
          this.$dialog.error(e.msg);
        });
    }
  }
};
</script>
<style>
.home {
  display: none !important;
}
/*  */
.showbox{
  position: fixed;
  width:100%;
  height:100%;
  z-index:666;
  background:#fff;
  color:rgba(0,0,0,0.9);
}
.showbox button{
  width:184px;
  background:#07c160;
  color:#fff;
  padding:10px 20px;
  display:block;
  margin:100px auto;
  border-radius:4px;
}
.showbox .showTile{
  overflow: hidden;
  line-height:30px;
  margin:40px 0 0 40px;
}
.showbox .showTile img{
  height:30px;
  margin-right:15px;
  background:#f5f5f5;
  display: block;
  float: left;
}
.showbox strong{
  font-size:24px;
  font-weight:normal;
  margin:20px 0 0 40px;
  display:block;
}
.showbox p{
  font-size:16px;
  margin:40px 0 0 40px;
}
/*  */
.img-code {
  width: 2rem;
  height: .8rem;
}
.codeInput {
  width: 3.4rem !important;
  height: .38rem;
  box-sizing: border-box;
  padding-left: .3rem;
}
.two-item {
  padding-top: .3rem !important;
}
</style>
